import * as yup from 'yup';

export const rsAllocationRuleValidationSchema = yup.object().shape({
  SKU: yup.string().required('SKU is required'),
  currencyId: yup.string().required('Currency is required'),
  amount: yup
    .number()
    .typeError('Amount must be a number')
    .required('Amount is required'),
});
